import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'sms-config',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./SmsConfig').default
      callback(null, component)
    }, 'SmsConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/SmsConfig/index.js